module.exports = __webpack_public_path__ + "static/media/move.d0bfe35e.svg";